module.exports = __webpack_public_path__ + "img/_super_04.eaf7c81e.jpg";